import { useRouterState } from "@tanstack/react-router";
import { ChatConversations } from "../chat/ChatConversations";
import { MailNav } from "./MailNav";

/**
 * The sidebar's second part (WP-056): the page's own list under the four sections. On Mail the
 * Inbox group and the mailboxes (`MailNav`), on Chat the channels and DMs; nothing elsewhere.
 * Collapsed to a rail, Mail's are icons and Chat's list goes back into its page.
 */
export function PageNav({ workspaceId, collapsed }: { workspaceId: string; collapsed: boolean }) {
  const location = useRouterState({ select: (s) => s.location });
  const path = /^\/w\/[^/]+\/([^/]+)(?:\/([^/]+))?/.exec(location.pathname);
  const section = path?.[1];
  if (section === "inbox") return <MailNav workspaceId={workspaceId} search={location.search} collapsed={collapsed} />;
  if (section === "chat" && !collapsed) {
    const channelId = path?.[2];
    return (
      <div className="flex min-h-0 flex-1 flex-col border-t border-border pt-3">
        <h2 className="px-3 pb-1 text-xs font-medium uppercase tracking-wide text-muted">Conversations</h2>
        <ChatConversations workspaceId={workspaceId} channelId={channelId === undefined ? null : channelId} />
      </div>
    );
  }
  return null;
}
